var PreviousWarrantyDialogModule = /** @class */ (function () {
    function PreviousWarrantyDialogModule() {
    }
    return PreviousWarrantyDialogModule;
}());
export { PreviousWarrantyDialogModule };
